module.exports = __webpack_public_path__ + "img/home.fa0f2468.png";